import type { LoginResponseDto } from 'src/contracts/auth';

/** Auth response from backend can include user on either `data` or `user` key */
type AuthStoragePayload = LoginResponseDto & { data?: LoginResponseDto['user'] };

const AUTH_STORAGE_KEY = 'auth';

export const saveAuthToStorage = (response: AuthStoragePayload) => {
  const normalizedResponse = {
    ...response,
    data: response.data || response.user,
  };
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(normalizedResponse));
};

export const getAuthFromStorage = (): LoginResponseDto | null => {
  const auth = localStorage.getItem(AUTH_STORAGE_KEY);
  return auth ? JSON.parse(auth) : null;
};

export const clearAuthFromStorage = () => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
};

export const removeAuthFromStorage = () => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
};
